import { render, staticRenderFns } from "./LvInfoOption.vue?vue&type=template&id=0940ef53&"
import script from "./LvInfoOption.vue?vue&type=script&lang=js&"
export * from "./LvInfoOption.vue?vue&type=script&lang=js&"
import style0 from "./LvInfoOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports